export default /* @ngInject */ function($q, authService, getOptionsDebounce) {
    return {
        require: 'ngModel',
        link: function(scope, element, attrs, ngModel) {
            ngModel.$options = getOptionsDebounce();
            ngModel.$asyncValidators.email_registered = (value) => {
                return $q((resolve, reject) => {
                    authService.isEmailRegistered({email: value})
                        .then(resolve) // 404 -> error, should exist
                        .catch(reject); // 200 -> continue, exists
                });
            };
        }
    };
}



// WEBPACK FOOTER //
// ./forms/validators/email-registered.js